module.exports = __webpack_public_path__ + "img/profit-dollar-hand.b2134cd3.svg";